import { Injectable } from "@angular/core";

enum FBQ_EVENTS {
  ADD_TO_CART = "AddToCart",
  CONTACT = "Contact",
  CUSTOMIZE_PRODUCT = "CustomizeProduct",
  INIT_CHECKOUT = "InitiateCheckout",
  VIEW_CONTENT = "ViewContent",
  SUBMIT_APP = "SubmitApplication",
  PURCHASE = "Purchase",
  LEAD = "Lead",
  COMPLETE_REGISTRATION = "CompleteRegistration",
}

declare const fbq: Function;

@Injectable({
  providedIn: "root",
})
export class UtilsService {
  constructor() {}

  public triggerAddToCart() {
    fbq("track", FBQ_EVENTS.ADD_TO_CART);
  }

  public triggerContract() {
    fbq("track", FBQ_EVENTS.CONTACT);
  }

  public triggerCustomizeProduct() {
    fbq("track", FBQ_EVENTS.CUSTOMIZE_PRODUCT);
  }

  public triggerInitCheckout() {
    fbq("track", FBQ_EVENTS.INIT_CHECKOUT);
  }

  public triggerViewContent() {
    fbq("track", FBQ_EVENTS.VIEW_CONTENT);
  }

  public triggerPurchase(value: number, currency: string) {
    fbq("track", FBQ_EVENTS.PURCHASE, { value, currency });
  }

  public triggerCompleteRegistration() {
    fbq("track", FBQ_EVENTS.COMPLETE_REGISTRATION);
  }

  public triggerLead() {
    fbq("track", FBQ_EVENTS.LEAD);
  }

  public triggerSubmitApplication() {
    fbq("track", FBQ_EVENTS.SUBMIT_APP);
  }

  public triggerCustomizeProductWithArgs(params: object) {
    this.triggerCustomFbqEvent("ChoosePlan", params);
  }

  private triggerCustomFbqEvent(event: string, params: object) {
    fbq("trackCustom", event, params);
  }
}
